<template>
	<!-- Search-by-paper (DCTL-2156): explains why a project surfaced when the
	     match came from a contained paper rather than the project name. The API
	     only populates matchedPapers when the project name itself did NOT match,
	     so the mere presence of entries is the signal to show this hint. -->
	<div
		v-if="matchedPapers.length"
		class="text-caption text-grey-darken-2 mt-1"
	>
		Matched paper:
		<span class="font-italic">{{ matchedPapers[0].name || "(untitled)" }}</span>
		<span v-if="matchedPapers[0].matchedField !== 'Title'">
			({{ matchedPapers[0].matchedField }} {{ matchedPapers[0].matchedValue }})
		</span>
		<span v-if="moreCount > 0"> +{{ moreCount }} more</span>
	</div>
</template>

<script>
export default {
	name: "ProjectPaperMatch",

	props: {
		item: {
			type: Object,
			required: true,
		},
	},

	computed: {
		matchedPapers() {
			return this.item.matchedPapers || [];
		},
		// Total matched papers minus the one shown, for the "+N more" suffix.
		moreCount() {
			const total = this.item.matchedPaperCount || this.matchedPapers.length;
			return Math.max(0, total - 1);
		},
	},
};
</script>
